import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { YMInitializer } from "react-yandex-metrika";

const METRIKA_ID = process.env.REACT_APP_METRIKA_ID;

const Metrics = () => {
	const location = useLocation();

	useEffect(() => {
		if (window.ym && METRIKA_ID) {
			window.ym(Number(METRIKA_ID), 'hit', location.pathname);
		}
	}, [location]);

	return METRIKA_ID ? <YMInitializer accounts={[Number(METRIKA_ID)]} options={{ webvisor: true, clickmap: true }} /> : null;
};

export default Metrics;